//
//
//
//
//
//
//
//

    export default {
        name: 'sy-cover',
        methods: {
    
        }
    }



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-cover.vue